const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      // cursor: 'pointer',
      display: 'block',
      padding: '8px 19px',
      textTransform: 'uppercase',
      width: 'fit-content',
      height: 'fit-content',
      fontSize: 12,
      lineHeight: 1,
      '&::after': {
        backgroundColor: theme.colors[0],
        width: '100%',
        height: '100%',
        borderRadius: 15,
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 0,
        transition: 'all 0.45s cubic-bezier(.17,.67,.3,1.33)',
      },
    },
    text: {
      position: 'relative',
      zIndex: 1,
      // color: 'transparent',
      // transition: `text-shadow .75s ${theme.easings.garret}`,
      display: 'inline-block',
      fontFamily: theme.fonts[0],
      fontWeight: 500,
      color: theme.colors[1],
    },
    // rootBackground: {
    //   display: 'inline-flex',
    //   alignItems: 'center',
    //   fontSize: 10,
    //   letterSpacing: '1px',
    //   textTransform: 'uppercase',
    //   padding: [8, 10],
    //   borderRadius: 30,
    //   background: theme.colors[8],
    //   fontWeight: 500,
    //   transition: `all 0.75s ${theme.easings.garret}`,
    //   backfaceVisibility: 'hidden',
    //   willChange: 'transform',
    //   '& $text': {
    //     padding: [0, 20],
    //   },
    // },
    rootHover: {
      cursor: 'pointer',
      // '& $circle': {
      //   transform: 'scale(1.1)',
      //   backgroundColor: theme.colors[1],
      // },
      // '& $arrow': {
      //   borderColor: `transparent transparent transparent ${theme.colors[4]} `,
      // },
      '@media (hover: hover)': {
        '&:hover': {
          '&::after': {
            transform: 'scale(1.15)',
          },
        },
      },
    },
    // rootDefautColor: {
    //   '& $text': {
    //     color: theme.colors[1],
    //   },
    //   '@media (hover: hover)': {
    //     '&:hover': {
    //       '& $text': {
    //         textShadow: `0 0 ${theme.colors[1]}, 0 -10px transparent`,
    //       },
    //     },
    //   },
    // },
    // rootLightColor: {
    //   '& $text': {
    //     textShadow: `0 10px transparent, 0 0 ${theme.colors[4]}`,
    //   },
    //   '@media (hover: hover)': {
    //     '&:hover': {
    //       '& $text': {
    //         textShadow: `0 0 ${theme.colors[4]}, 0 -10px transparent`,
    //       },
    //     },
    //   },
    //   '&$rootBackground': {
    //     '& $text': {
    //       textShadow: `0 10px transparent, 0 0 ${theme.colors[3]}`,
    //     },
    //     '& $circle': {
    //       backgroundColor: theme.colors[3],
    //     },
    //     background: theme.getRgba(theme.colors[4], 0.2),
    //     '@media (hover: hover)': {
    //       '&:hover': {
    //         '& $text': {
    //           textShadow: `0 0 ${theme.colors[3]}, 0 -10px transparent`,
    //         },
    //         '& $arrow': {
    //           borderColor: `transparent transparent transparent ${theme.colors[1]} `,
    //         },
    //       },
    //     },
    //   },
    // },
    // rootDarkColor: {
    //   '& $text': {
    //     textShadow: `0 10px transparent, 0 0 ${theme.colors[3]}`,
    //   },
    //   '& $circle': {
    //     backgroundColor: theme.colors[3],
    //   },
    //   '@media (hover: hover)': {
    //     '&:hover': {
    //       '& $text': {
    //         textShadow: `0 0 ${theme.colors[3]}, 0 -10px transparent`,
    //       },
    //       '& $circle': {
    //         backgroundColor: theme.colors[4],
    //       },
    //       '& $arrow': {
    //         borderColor: `transparent transparent transparent ${theme.colors[1]}`,
    //       },
    //     },
    //   },
    // },
    // circle: {
    //   width: 34,
    //   height: 34,
    //   backgroundColor: theme.colors[4],
    //   borderRadius: '50%',
    //   display: 'flex',
    //   alignItems: 'center',
    //   justifyContent: 'center',
    //   transition: `all 0.75s ${theme.easings.garret}`,
    //   backfaceVisibility: 'hidden',
    //   willChange: 'transform',
    // },
    // arrow: {
    //   width: 0,
    //   height: 0,
    //   borderStyle: 'solid',
    //   borderWidth: '3.5px 0 3.5px 4px',
    //   borderColor: `transparent transparent transparent ${theme.colors[1]}`,
    //   backfaceVisibility: 'hidden',
    //   willChange: 'transform',
    //   transition: `all 0.75s ${theme.easings.garret}`,
    // },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
